// Logic for page illustrators profile
window.$(document).ready(function () {
  window.$('.upload-avatar').click(function (click) {
    click.preventDefault();
    window.$('input.crop-avatar').click();
  });
  window.$('.upload-label').click(function (click) {
    click.preventDefault();
    window.$('input.crop-label').click();
  });
  window.$('input.crop-illustrator-image').change(function () {
    let modalHtml = window.$('#crop-image').clone();
    let inputParent = window.$(this).parent();
    let errorBox = window.$(this).siblings('.alert-box--error');
    let formData = new FormData();
    let loader = window.$(this).siblings('.loader-wrap');
    let illustratorImage = document.getElementById($(this).attr('id')).files[0];
    if (!illustratorImage.type.match('image.*')) {
      return false;
    }
    let illustratorImageType = $(this).data('image-type');
    let fileId = $(this).attr('data-file-id');

    errorBox.hide();
    loader.show();
    formData.append('type', illustratorImageType);
    formData.append(illustratorImageType, illustratorImage);
    formData.append('file_id', fileId);

    let minCanvasWidth = 550,
      minCanvasHeight = 550;
    if (illustratorImageType === 'label') {
      minCanvasWidth = 700;
      minCanvasHeight = 700;
    }

    axios.post('/ajax/' + illustratorImageType + '/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {
        loader.hide();

        $(this).attr('data-file-id', response.data.file_id);
        if (response.data.imagePath) {
          if (illustratorImageType == 'avatar') {
            $('.ill-avatar').attr('src', response.data.imagePath);
            $('.ill-nav-avatar').attr('src', response.data.imagePath);
          } else {
            $('.ill-thumb').attr('src', response.data.imagePath);
          }
        } else {
          if (illustratorImageType == 'avatar') {
            $('.ill-avatar').attr('src', response.data.original_image_path);
            $('.ill-nav-avatar').attr('src', response.data.original_image_path);
          } else {
            $('.ill-thumb').attr('src', response.data.original_image_path);
          }
        }

        window.$('small', inputParent).removeClass('text-danger');
        let cropper = null;
        window.$('#image-to-crop').attr('src', response.data.original_image_path);
        window.$('#crop-image').modal({
          backdrop: 'static'
        });
        window.$('#crop-image').on('shown.bs.modal', function () {
          if (cropper) {
            cropper.destroy();
          }
          let image = document.getElementById('image-to-crop');

          cropper = new Cropper(image, {
            viewMode: 2,
            autoCropArea: 1,
            aspectRatio: 1,
            autoCrop: true,
            restore: false,
            // minCanvasWidth: minCanvasWidth,
            // minCanvasHeight: minCanvasHeight,
            crop: function (cropDetails) {
              if (Math.ceil(cropDetails.detail.width) < minCanvasWidth || Math.ceil(cropDetails.detail.height) < minCanvasHeight) {
                cropper.setData({width: minCanvasWidth, height: minCanvasHeight});
              }
            },
            zoom: function (e) {
              if (e.detail.ratio > 1) {
                e.preventDefault();
                cropper.zoomTo(0.99);
              }
            },
          });
          window.$('.rotate-right').click(function (event) {
            event.preventDefault();
            cropper.rotate(45);
          });
          window.$('.rotate-left').click(function (event) {
            event.preventDefault();
            cropper.rotate(-45);
          });
          window.$('.zoom-in').click(function (event) {
            event.preventDefault();
            cropper.zoom(0.1);
          });
          window.$('.zoom-out').click(function (event) {
            event.preventDefault();
            cropper.zoom(-0.1);
          });
          window.$('.cancel-crop').click(function (event) {
            event.preventDefault();
            cropper.reset();
          });
          window.$('.save-crop').click(function (click) {
            click.preventDefault();
            let cropInfo = cropper.getData(true);
            cropInfo.key = response.data.id;
            cropInfo.image_extension = response.data.image_extension;
            cropInfo.type = illustratorImageType;
            cropInfo.backup = response.data.backup;

            // apply crop changes and set
            axios.post('/ajax/' + illustratorImageType + '/transform', cropInfo)
              .then((transformResponse) => {
                response.data[illustratorImageType] = transformResponse.data[illustratorImageType] + "?" + new Date().getTime() + Math.floor(Math.random() * 100);
                cropper.destroy();

                window.$('#crop-image').modal('hide');

                if (illustratorImageType == 'avatar') {
                  $('.ill-avatar').attr('src', transformResponse.data.imagePath);
                  $('.ill-nav-avatar').attr('src', transformResponse.data.imagePath);

                  window.$('#alert-upload-profile-image').fadeOut();
                } else {
                  $('.ill-thumb').attr('src', transformResponse.data.imagePath);

                  window.$('#alert-upload-directory-thumbnail').fadeOut();
                }
              });
          });
        });
        window.$('#crop-image').on('hidden.bs.modal', () => {
          window.$('#crop-image').after(modalHtml).remove();
        });
        window.$('button.delete-image').click((click) => {
          click.preventDefault();
          cropper.destroy();
          window.$('#crop-image').modal('hide');
        });
      }).catch(() => {
        loader.hide();
        window.$('input.crop-illustrator-image').val('');
        errorBox.show().find('.alert-box-inner').text(`Error: File must be at least ${minCanvasWidth}x${minCanvasHeight}px. JPG or PNG.`);
      });
  });
  window.$('input.ajax-load.illustrator').change(function () {
    let inputParent = window.$(this).parent();
    let formData = new FormData();
    let image = document.getElementById('image').files[0];
    if (!image.type.match('image.*')) {
      return false;
    }
    formData.append('image', image);
    axios.post('/ajax/image/upload', formData,
      {
        headers: {'content-type': 'multipart/form-data'}
      })
      .then((response) => {
        window.$('.image-cell', inputParent).css('background', "url('/" + response.data.image + "') no-repeat center center / 100% 100%");
      });
  });
  window.$('button.default-image').click(function (click) {
    click.preventDefault();
    window.$('.image-cell', $(this).parent()).css('background', $(this).data('default-image'));
    let indicatorInputName = window.$('.upload-avatar', $(this).parent()).data('indicator-input-name');
    window.$('input[name=' + indicatorInputName + ']').val('');
    window.$('input[type=file]', $(this).parent()).val('');
  });
});